import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Shift } from 'src/app/classes/shift';
import { ShiftService } from 'src/app/services/shift.service';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.scss'],
})
export class CancelComponent  implements OnInit {
  shift = new Shift()

  cancel_reason = ''

  constructor(public activeModal: NgbActiveModal,
    private shiftService: ShiftService
  ) { }

  ngOnInit() {
    this.shiftService.shift(this.shift.id).subscribe(shift => {
      this.shift = shift
    })
  }

  cancel() {
    this.shiftService.cancel(this.shift.id, this.cancel_reason).subscribe(shift => {
      this.activeModal.close('close')
    })
  }
}
